import React, { useEffect, useState } from "react";
import classnames from "classnames";
import "./styles.less";
import Select, { Option } from "rc-select";
export const Input = (props) => {
  const { error = false, className, inputRef, ...restProps } = props;
  const cls = classnames({
    "authing-input": true,
    error: !!error,
    [className]: !!className,
  });
  const componentProps = {
    ...restProps,
    className: cls,
    ref: inputRef,
  };
  return <input {...componentProps}></input>;
};

export const SelectRc = (props) => {
  const {
    options,
    error = false,
    setError,
    className,
    selectRef,
    currentValue,
    setCurrentValue,
    ...restProps
  } = props;
  const cls = classnames({
    "authing-select": true,
    error: !!error,
    [className]: !!className,
  });
  useEffect(() => {}, []);
  const componentProps = {
    ...restProps,
    className: cls,
    ref: selectRef,
  };
  // useEffect(()=>{

  // })
  const onChange = (e) => {
    let value;
    if (e && e.target) {
      ({ value } = e.target);
    } else {
      value = e;
    }
    setCurrentValue(value);
  };

  const menuItemSelectedIcon = (props) => {
    const { ...p } = props;
    return (
      <span style={{ position: "absolute", right: 0 }}>
        {p.isSelected ? "🌹" : "☑️"}
      </span>
    );
  };
  const singleItemIcon = (
    <span
      style={{ position: "absolute", right: "0px" }}
      role="img"
      aria-label="rose"
    >
      🌹
    </span>
  );
  return (
    <>
      <Select
        {...componentProps}
        style={{ width: "100%" }}
        showArrow
        inputIcon={
          <i
            class="icon authing-icon authing-expand_more_black_24dp"
            style={{ color: "#4E5969" }}
          ></i>
        }
        // menuItemSelectedIcon={singleItemIcon}
        // tagRender={tagRender}
        showSearch={false}
        onChange={onChange}
        dropdownClassName="authing-select-dropdown"
        // onBlur={setError(false)}
      >
        {options.map((option, index) => (
          <Option
            value={option?.value || option}
            className="authing-select-option"
            key={`${index}+"option"`}
          >
            {option?.label || option}
          </Option>
        ))}
      </Select>
    </>
  );
};
